<template>
  <div>
    <div v-if="!$store.getters.isNavActiveTabCorridors" id="afdc-fuel-legend" class="afdc-legend mapboxgl-ctrl">
      <div v-if="!isMobileView">
        <div class="afdc-legend-title">{{ $t('Legend') }}</div>
        <ul>
          <li v-for="fuel in activeFuels" v-bind:key="fuel.key">
            <img v-bind:src="require(`../assets/images/markers/${fuel.key}.svg`)" alt="">{{ fuel.shortName }}
          </li>
        </ul>
      </div>
      <div v-else>
        <div v-if="!showMobileLegend" class="afdc-mobile-legend-button afdc-mobile-legend-container" @click="toggleLegend">
          <span class="afdc-sr-only">{{ $t('Open legend') }}</span>
          <font-awesome-icon icon="plus-circle" class="afdc-fa-icon"/>
          {{ $t('Legend') }}
        </div>
        <div v-if="showMobileLegend" class="afdc-show-mobile-legend">
          <div class="afdc-mobile-legend-container afdc-legend-title" v-on:click="closeLegend" >
            <span class="afdc-sr-only">{{ $t('Close legend') }}</span>
            <font-awesome-icon icon="minus-circle" class="afdc-fa-icon"/>
            {{ $t('Legend') }}
          </div>
          <ul>
            <li v-for="fuel in activeFuels" v-bind:key="fuel.key">
              <img v-bind:src="require(`../assets/images/markers/${fuel.key}.svg`)" alt="">{{ fuel.shortName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else id="afdc-corridor-legend" class="afdc-legend mapboxgl-ctrl">
      <div class="afdc-legend-title">{{ $t('Legend') }}</div>
      <div v-if="corridorRouteMode === true">
        <div class="afdc-legend-element">
          <div class="afdc-corridor-line afdc-ready-line" :style="{ backgroundColor: corridorColor.ready }"></div>
          <div><span>{{ $t('Ready Corridor') }}</span> <span :content="tooltipContent.ready" id="ready-icon" class="afdc-corridor-tooltip"  v-tippy="{arrow : true, arrowType : 'round'}"><font-awesome-icon icon="info-circle" class="afdc-fa-icon afdc-legend-info-icon"/></span></div>
        </div>
        <div class="afdc-legend-element">
          <div class="afdc-corridor-line afdc-pending-line" :style="{ backgroundColor: corridorColor.pending }"></div>
          <div><span>{{ $t('Pending Corridor') }}</span><span class="afdc-corridor-tooltip" :content="tooltipContent.pending" v-tippy="{arrow : true, arrowType : 'round'}"><font-awesome-icon icon="info-circle" class="afdc-fa-icon afdc-legend-info-icon"/></span></div>
        </div>
      </div>
      <div v-if="this.$store.getters.isNavActiveTabCorridorsSearchPresent && corridorStationMode === true">
        <div class="afdc-legend-element">
          <div class="afdc-corridor-line afdc-selected-line"></div>
          <div><span>{{ $t('Selected Route') }}</span></div>
        </div>
        <div class="afdc-legend-element">
          <div class="afdc-corridor-line afdc-alternate-line"></div>
          <div><span>{{ $t('Alternate Route') }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      added: false,
      showMobileLegend: false,
      shortFuelNames: {
        BD: this.$t('Biodiesel'),
        CNG: this.$t('CNG'),
        E85: this.$t('Ethanol'),
        LNG: this.$t('LNG'),
        LPG: this.$t('Propane'),
        RD: this.$t('Renewable Diesel'),
      },
      tooltipContent: {
        ready: this.$t('Highways with enough stations to support travel with a minimum distance between stations based on the fuel type.'),
        pending: this.$t('Highways that have some stations to support travel but don\'t yet meet the minimum distance requirement or the fuel-specific station criteria.'),
      },
    };
  },

  computed: {
    isMobileView() {
      return this.$store.getters.isMobileView;
    },

    corridorRouteMode() {
      return this.$store.getters.getFilterValueWithDefault('show_corridor_routes');
    },

    corridorStationMode() {
      return this.$store.getters.getFilterValueWithDefault('show_corridor_stations');
    },

    corridorColor() {
      const fuelColors = this.$store.getters.getCorridorColors;
      const fuel = this.$store.getters.getFilterValueWithDefault('fuel')[0];
      return {
        ready: fuelColors[fuel].ready,
        pending: fuelColors[fuel].pending,
      };
    },

    activeFuels() {
      const fuels = this.$store.getters.loaderFuels;

      // Store the active fuels in an object for more efficient lookups in the
      // next loop (rather than searching the fuels array on each loop).
      const activeFuelKeys = {};
      const activeFuelKeysArr = this.$store.getters.getFilterValueWithDefault('fuel');
      for (let i = 0, len = activeFuelKeysArr.length; i < len; i += 1) {
        activeFuelKeys[activeFuelKeysArr[i]] = true;
      }

      const activeFuels = [];
      for (let i = 0, len = fuels.length; i < len; i += 1) {
        const fuel = fuels[i];
        if (fuel.key !== 'all' && (activeFuelKeys.all || activeFuelKeys[fuel.key])) {
          activeFuels.push({
            key: fuel.key,
            shortName: this.shortFuelNames[fuel.key] || fuel.name,
          });
        }
      }

      return activeFuels;
    },
  },

  methods: {
    onAdd() {
      this.added = true;
      return this.$el;
    },

    onRemove() {
      this.added = false;
      this.$el.parentNode.removeChild(this.$el);
    },
    toggleLegend() {
      const showLegend = this.showMobileLegend === true ? this.showMobileLegend = false : this.showMobileLegend = true;
      return showLegend;
    },
    closeLegend() {
      this.showMobileLegend = false;
    },
  },
};
</script>

<style lang="scss">
  #fuel-legend {
    width: 100px;
  }

  #corridor-legend {
    width: 180px;

    .corridor-line {
      width: 40px;
      height: 5px;
      margin-right: 5px;
    }

    .legend-element {
      display: flex;
      align-items: center;
    }

    .selected-line {
      background-color: #000;
    }

    .alternate-line {
      background-color: #969696;
    }

    .legend-info-icon {
      margin-left: 5px;
    }
  }

  .mobile-legend-container {
    display: flex;
    justify-content: left;
    cursor: pointer;
    align-items: center;
  }

  .legend {
    color: #666;
    font-size: 12px;
    background-color: #fff;
    padding: 5px 10px;
    border: 1px solid #ddd;

    .legend-title {
      text-align: center;
      font-size: 13px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ddd;
    }

    ul {
      list-style: none;
      margin: 10px 0 0 0;
      padding: 0;

      li {
        margin-bottom: 5px;
        padding-left: 18px;
        text-indent: -18px;
      }

      img {
        width: 10px;
        margin: 0 8px 3px 0;
      }
    }
  }
</style>
